module.exports = __webpack_public_path__ + "img/ofendendo.eff8b81c.png";